import React, { useEffect, useRef } from 'react';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  getPaginationOpts, getResponseError, responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getNotificationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import { loadNotification, markAllNotification } from '../actions';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import {
  dateFormatterWithTooltip,
  tooltipFormatter,
} from '../../../utils/formatters';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import NotificationDTO from '../../../dto/NotificationDTO';
import Grid from '../../../components/base/Grid/Grid';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { NOTIFICATION_STATUS_MARK_LIST } from '../../../configs';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';

export default function NotificationsPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const pageName = 'notification';
  const filterName = `${pageName}-filter`;
  const store = useStore();
  const notificationColumns = [
    {
      dataField: 'created_at',
      text: 'Создание',
      disableSort: true,
      formatter: date => dateFormatterWithTooltip(date),
      headerClassName: 'notification-created-at-column',
    },
    {
      dataField: 'type_label',
      text: 'Тип уведомления',
      disableSort: true,
      headerClassName: 'notification-subject-type-column',
    },
    {
      dataField: 'message',
      text: 'Текст',
      disableSort: true,
      formatter: a => tooltipFormatter(a),
      headerClassName: 'notification-message-column',
    },
    {
      dataField: 'read_at',
      text: 'Прочитано',
      disableSort: true,
      formatter: date => dateFormatterWithTooltip(date),
      headerClassName: 'notification-read-at-column',
    },
  ];

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0],
    created_at_to: defaultDate[1],
  };

  const {
    notificationMeta,
    notification,
    loadingNotification,
  } = useSelector(getNotificationData);

  const DTO = new NotificationDTO();
  const attributes = DTO.getAttributesByName();

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: {} });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[AUTHORIZED_MODULE].notificationMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData },
    };
    const p1 = dispatch(loadNotification(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const handleIsMarkAll = () => {
    dispatch(markAllNotification()).then(() => {
      successNotification('Уведомления', 'Все уведомления прочтены');
    }).catch(response => {
      errorNotification('Уведомления', getResponseError(response));
    });
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  return (
    <div className="page notification-page">
      <Loader loading={loadingNotification} />
      <div className="page-title">
        <div className="title-text">Уведомления</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
              )}
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            hideSmallButtons
            dtoObject={attributes.created_at}
            showArrowIcon
            usePortal
            placeholder="Дата подачи"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.only_unread}
            usePortal
            placeholder="Статус"
            className="no-border"
            options={NOTIFICATION_STATUS_MARK_LIST}
          />
          <div className="filter-sep" />
          <Button onClick={handleIsMarkAll}>Пометить прочитанными</Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <Grid
                key={pageName}
                onClickByRow={() => {}}
                data={notification}
                columns={notificationColumns}
                name={`${pageName}-list`}
              />
            </div>
          </div>
          <Pagination meta={notificationMeta} list={notification} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
